import React, { useEffect, useState } from "react";
import {
  Box,
  sx,
  Text,
  AtlasButton,
  VisuallyHidden,
  Stack,
} from "@fuegokit/react";
import { useDrag, useDrop } from "@fuegokit/react";
import { AkDragHandlerIcon } from "@fuegokit/fuegoicons-react";
import styled from "styled-components";

const DraggableBoxVerticalDropTarget = () => {
  const [domLoaded, setDomLoaded] = useState(false);
  useEffect(() => {
    setDomLoaded(true);
  }, []);
  const [dropped, setDropped] = React.useState(null);
  const ref = React.useRef(null);
  const { dropProps } = useDrop({
    ref,
    async onDrop(e) {
      if (e.textItems) {
        const textItems = e.textItems.map((item) => item.getText("text/plain"));

        setDropped(`Dropped`);
      }
      if (e.fileItems) {
        return;
      }
      if (e.directoryItems) {
      }
    },
  });

  return (
    <Box
      {...dropProps}
      role="button"
      tabIndex={0}
      ref={ref}
      sx={{ padding: 6 }}
    >
      {dropped}
    </Box>
  );
};

const DraggableBoxExampleWrapper = ({ children }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        p: 4,
        fontSize: 3,
      }}
    >
      <Box sx={{ p: 2 }}>
        <Stack size={4}>{children}</Stack>
      </Box>

      <Box sx={{ p: 2, border: "1px dashed", borderColor: "border.default" }}>
        <DraggableBoxVerticalDropTarget />
      </Box>
    </Box>
  );
};

const BasicUseDragExample = () => {
  const preview = React.useRef(null);
  const [moved, setMoved] = React.useState(false);
  const dragData = {
    "text/plain": "currently beeing dragged",
    "text/html": "<strong>currently beeing dragged</strong>",
    "fk/object": JSON.stringify({
      message: "currently being dragged",
      style: "bold",
    }),
  };

  useEffect(() => {
    if (moved) {
      console.log("moved");
    }
  }, [moved]);

  const { dragState, dragProps, isDragging } = useDrag(preview, dragData);

  // @TODO: we need to get this logic working
  // so people can re-render
  // if (dragState.moved) {
  //   return (
  //     <DraggableBoxExampleWrapper>
  //       <VisuallyHidden>moved</VisuallyHidden>
  //       <Box>
  //         <AtlasButton onClick={() => setMoved(false)}>Reset</AtlasButton>
  //       </Box>
  //     </DraggableBoxExampleWrapper>
  //   )
  // }

  return (
    <DraggableBoxExampleWrapper>
      {!dragState.moved ? (
        <Box
          {...dragProps}
          className={`draggable ${isDragging ? "dragging" : ""}`}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            border: "1px solid",
            borderColor: "border.default",
            p: 4,
            borderRadius: 1,
            backgroundColor: "background.neutral.subtle.default",
            ":hover": {
              backgroundColor: "background.neutral.subtle.hovered",
              cursor: isDragging ? "grabbing" : "grab",
            },
            ":active": {
              cursor: isDragging ? "grabbing" : "grab",
            },
          }}
        >
          <Box
            as="span"
            aria-label="Drag"
            sx={{
              ":hover": {
                cursor: isDragging ? "grabbing" : "grab",
              },
              ":active": {
                cursor: isDragging ? "grabbing" : "grab",
              },
            }}
          >
            <AkDragHandlerIcon />
          </Box>
          <span>
            This is a Box with drag props spread on it. The button inside is
            focusable.
          </span>
          <AtlasButton onClick={() => alert("action")}>Action</AtlasButton>
        </Box>
      ) : null}
    </DraggableBoxExampleWrapper>
  );
};
export default BasicUseDragExample;
